import { render } from "./fugaojianyan-news.vue?vue&type=template&id=7ea9469f&scoped=true"
import script from "./fugaojianyan-news.vue?vue&type=script&lang=js"
export * from "./fugaojianyan-news.vue?vue&type=script&lang=js"

import "./fugaojianyan-news.vue?vue&type=style&index=0&id=7ea9469f&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea9469f"]])

export default __exports__